import { ejecutarExpresion } from './ejecutarExpresion.js'
import { parsearArgumentosFuncion } from './parsearArgumentosFuncion.js'
import { funcionesPersonalizadas } from '../funciones/index.js'

export function ejecutarFuncion(nombreFuncion, argumentosCrudos, datos) {
  const fn = funcionesPersonalizadas[nombreFuncion]

  if (!fn) {
    console.error('❌ Función no encontrada:', nombreFuncion)
    return ''
  }

  const argumentosParseados = parsearArgumentosFuncion(argumentosCrudos)

  const valoresArgumentos = argumentosParseados.map((arg) => {
    switch (arg.tipo) {
      case 'variable':
        return ejecutarExpresion(`v:${arg.valor}`, datos)

      case 'imagen':
        return `i:${arg.valor}` // La capa 4 lo procesa

      case 'funcion':
        return ejecutarExpresion(arg.valor, datos)

      case 'literal':
      default:
        return arg.valor
    }
  })

  try {
    return fn(...valoresArgumentos)
  } catch (error) {
    console.error(`❌ Error ejecutando función ${nombreFuncion}:`, error)
    return ''
  }
}
